// no-arabic.directive.ts
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoArabic]'
})
export class NoArabicDirective {

  private arabicRegex = /[ \u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u0660-\u0669]/;

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (this.arabicRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    if (this.arabicRegex.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
